import styled, { keyframes } from 'styled-components';
import type { WithSX } from '@elfsight/lib-utils';
import { applySX } from '@elfsight/lib-utils';

interface SkeletonProps {
  width: number | string;
  height: number | string;
  className?: string;
  borderRadius?: number | string;
  color?: string;
}

export function Skeleton({
  width,
  height,
  className,
  borderRadius = 4,
  color: loaderColor = 'rgb(210, 210, 210)'
}: SkeletonProps) {
  return (
    <StyledSkeleton
      className={className}
      $sx={{
        width,
        height,
        borderRadius,
        backgroundColor: loaderColor
      }}
    />
  );
}

const blinker = keyframes`
  from {
    opacity: 0.4;
  }
  to {
    opacity: 1;
  }
`;

const StyledSkeleton = styled.div<WithSX>`
  ${applySX};
  animation: ${blinker} 1.5s ease-in-out infinite alternate;
  opacity: 0.4;
`;
